import createLucideIcon from '../createLucideIcon';

const Circle = createLucideIcon('Circle', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
]);

export default Circle;
